import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MarkdownModule } from 'ngx-markdown';
import { AmIconModule } from '../am-icon/am-icon.module';
import { CodeComponent } from './code.component';

@NgModule({
  declarations: [CodeComponent],
  imports: [
    CommonModule,
    AmIconModule,
    ClipboardModule,
    MatButtonModule,
    MarkdownModule.forRoot(),
  ],
  exports: [CodeComponent],
})
export class CodeModule {}
